import { Sticker, ScanLine, PhoneCall } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Sticker,
    title: "Stick it on your windshield",
    body: "Peel the SECQRE sticker, place it on the inside of your windshield, register it in 30 seconds via the app.",
  },
  {
    n: "02",
    icon: ScanLine,
    title: "Anyone scans the QR",
    body: "No app needed for the scanner. Phone camera, Google Lens, or any QR reader opens your private contact page.",
  },
  {
    n: "03",
    icon: PhoneCall,
    title: "You get a masked call",
    body: "Call routes through a one-time bridge. Your real number is never displayed. Pause anytime.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="section-pad bg-[#F8F9FA] border-y border-[#E2E8F0]">
      <div className="container-secqre">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <span className="overline">— How it works</span>
            <h2 className="mt-4 font-heading font-bold text-4xl sm:text-5xl tracking-tight" data-testid="hiw-heading">
              30 seconds to install.<br />Years of peace of mind.
            </h2>
            <p className="mt-5 text-lg text-[#475569]">
              No wiring. No subscription headaches. One sticker, a free app, and a contact channel
              that respects the most valuable thing on your phone — your number.
            </p>

            <div className="mt-10 relative rounded-2xl border border-[#E2E8F0] bg-white p-3">
              <img
                src="https://customer-assets.emergentagent.com/job_tech-secqre/artifacts/kw7jrk1o_WhatsApp%20Image%202026-05-18%20at%207.57.38%20PM%20%281%29.jpeg"
                alt="SECQRE sticker annotated — Scan the code to contact the vehicle owner"
                className="w-full rounded-xl"
                data-testid="hiw-annotated"
              />
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid gap-5">
              {STEPS.map((s, i) => (
                <div key={i} className="group flex gap-6 rounded-2xl border border-[#E2E8F0] bg-white p-7 md:p-8 transition-all hover:border-[#0F172A] hover:-translate-y-1" data-testid={`hiw-step-${i + 1}`}>
                  <div className="font-heading font-black text-5xl md:text-6xl tabular-nums text-[#E2E8F0] group-hover:text-[#FFD600] transition-colors leading-none">
                    {s.n}
                  </div>
                  <div className="flex-1">
                    <div className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-[#F8F9FA] mb-3">
                      <s.icon className="w-5 h-5 text-[#0F172A]" />
                    </div>
                    <h3 className="font-heading font-bold text-2xl">{s.title}</h3>
                    <p className="mt-2 text-[#475569] leading-relaxed">{s.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
